import ClientLottiePlayer from "./ClientLottiePlayer";

export default function ClientLottie({
  options = {},
  width,
  height,
  style,
  isStopped,
}) {
  const { loop = true, autoplay = true, animationData } = options;

  return (
    <ClientLottiePlayer
      loop={loop}
      play={autoplay && !isStopped}
      animationData={animationData}
      style={{
        ...(width != null ? { width } : {}),
        ...(height != null ? { height } : {}),
        ...style,
        margin: "auto",
      }}
    />
  );
}
